// extracted by mini-css-extract-plugin
export var cell = "_5r-4";
export var headerCell = "_5r-2";
export var rowHeader = "_5r-3";
export var table = "_5r-1";
export var tableContainer = "_5r-0";